/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassUnitLibraryWindow = Prefab.createWindow(
    "season_pass_unit_library_window",
    "unit_library_window_prefab_json",
    {
        bundles: SeasonPassLogic.listWindowBundles,
        theme: (mission) => bundles[`season_pass_${mission.logic.period}`].jsons[`theme_${mission.logic.period}`]
    }
);
